@import (reference) '../../../../constants/screen-width-breakpoints.module.less';
@import (reference) '../../../../constants/spacing.module.less';
@import (reference) '../../settings-page.module.less';

.container {
  padding: @settings-page-content-padding;
  max-width: 1440px;
  min-width: 368px;
  min-height: 100%;
}

.title-content {
  word-wrap: break-word;
  margin-bottom: @space-16;
}

.two-column-layout {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: @space-24;

  @media @tablet {
    grid-template-columns: 1fr;
  }

  @media @mobile {
    grid-template-columns: 1fr;
  }
}

.left-column {
  min-width: 0;
}

.right-column {
  @media @tablet, @mobile {
    order: -1;
  }
}

.description {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: @space-4;
  font-weight: 400;
  color: var(--grey-700);
  max-width: calc(100% - 400px - @space-24);

  @media @tablet, @mobile {
    max-width: 100%;
  }
}

.insurance-card {
  display: grid;
  grid-template-columns: 160px auto;
  column-gap: @space-24;
  width: 100%;
  border: 1px var(--grey-300) solid;
  border-radius: 8px;
  padding: @space-16;
  background: var(--white);

  @media @desktop {
    column-gap: @space-12;
    padding: @space-16;
  }

  @media @tablet {
    grid-template-columns: 120px auto;
    column-gap: @space-8;
    padding: @space-16;
  }

  @media @mobile {
    grid-template-columns: auto;
    padding: @space-16;
  }
}

.insurance-logo {
  width: 160px;
  height: 100%;

  @media @tablet, @mobile {
    width: 120px;
    margin-left: auto;
    margin-right: auto;
  }

  img {
    width: 100%;
  }
}

.insurance-details {
  line-height: normal;

  .insurance-title {
    line-height: 30px;
    font-weight: 500;
    margin-bottom: @space-4;

    @media @mobile {
      font-size: 16px;
      font-weight: 600;
      height: 30px;
    }
  }

  .insurance-description {
    font-size: 14px;
    line-height: 24px;
  }

  .insurance-help-links {
    margin-top: @space-12;

    a {
      font-size: 14px;
      line-height: 18px;
      color: var(--blue-600);
      text-decoration: none;
      display: flex;
      align-items: center;
      gap: @space-4;

      &:hover {
        text-decoration: underline;
      }

      .external-link-icon {
        margin-left: @space-4;
        flex-shrink: 0;
      }
    }
  }
}

.add-parcelguard-button {
  margin-top: @space-8;

  @media @mobile {
    width: 100%;
  }
}

.insurance-promo-wrapper {
  border: 1px var(--grey-300) solid;
  border-radius: 8px;
  padding: @space-16;
  overflow: hidden;
  background-color: var(--white);
}

.activate-insurance-section {
  padding-top: @space-16;
  margin-top: @space-16;
  border-top: 1px solid var(--grey-300);
}

.insurance-settings-card {
  border: 1px var(--grey-300) solid;
  border-radius: 8px;
  padding: @space-16;
  margin-top: @space-16;
  background-color: var(--white);

  @media @tablet, @mobile {
    padding: @space-16;
  }
}

.section-separator {
  border-top: 1px solid var(--grey-300);
  margin: @space-24 0;
}

.automation-rules-message {
  font-size: 12px;
  line-height: 18px;
  color: var(--grey-700);
  margin-top: @space-12;

  a {
    color: var(--blue-600);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.why-insurance-card {
  border: 1px var(--grey-300) solid;
  border-radius: 8px;
  padding: @space-16;
  background-color: var(--white);

  .list-title {
    margin-bottom: @space-12;
  }

  ul {
    margin-left: @space-24;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: @space-12;
  }

  li {
    display: list-item;
    list-style-type: disc;
  }

  a {
    font-size: 14px;
    line-height: 18px;
  }
}

.external-link-icon {
  height: 12px;
  width: 12px;
  margin-left: @space-4;
}

.apply-insurance-section {
  font-weight: 400;
  line-height: 18px;

  &:not(:first-child) {
    margin-top: @space-24;
  }

  .apply-insurance-title {
    font-size: 16px;
    line-height: 30px;
    font-weight: 500;
    margin-bottom: @space-4;

    @media @mobile {
      font-size: 16px;
      font-weight: 600;
      height: 30px;
    }
  }

  .apply-insurance-toggle-section {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: @space-8;

    .insurance-slider {
      width: 100%;
      label {
        flex-direction: row-reverse;
        justify-content: space-between;
        width: 100%;
      }
    }
  }

  .apply-insurance-details-description {
    font-size: 12px;
    line-height: 18px;
    color: var(--grey-700);
    margin-top: @space-8;
  }
}
